<h2 mat-dialog-title class="text-center">
  {{ 'pages.Termsconditions.Termsconditions' | translate}}
  <span>
    <i
      class="mi mi-close d-inline dialog-close float-end cur-point"
      mat-dialog-close
      (click)="closeDialog($event)"
    ></i>
  </span>
</h2>

<div class="card-body">
  <iframe
  src="https://imageblobs.blob.core.windows.net/webpage/terms_conditions.pdf"
  type="application/pdf"
  frameBorder="0"
  scrolling="auto"
  height="900px"
  width="100%"></iframe>
  <!-- <pdf-viewer [src]="pdfSrc"
              [render-text]="true"
              style="display: block;"
  ></pdf-viewer> -->
</div>
